import { Vue } from 'vue-property-decorator';
import fetch from '@/helpers/fetch';

export default {
	state: {
		selectedTrialId: null,
		decisionsPerTrial: {},
	},
	mutations: {
		SET_DECISIONS_PER_TRIAL(state, dec) {
			Vue.set(
				state.decisionsPerTrial,
				dec.trialId,
				dec.decisions,
			);
		},
		SET_SELECTED_TRIAL_ID(state, trialId) {
			state.selectedTrialId = trialId;
		},
	},
	actions: {
		fetchDecisions: async function(context, trialId: number): Promise<object[]> {
			const data = await fetch.get('/api/decisions/' + trialId);

			context.commit(
				'SET_DECISIONS_PER_TRIAL',
				{
					trialId: trialId,
					decisions: data,
				},
			);

			return data;
		},
		selectDecisions: function(context, trialId: number | string): void {
			context.commit('SET_SELECTED_TRIAL_ID', trialId);

			if (trialId === 'new') {
				context.commit(
					'SET_DECISIONS_PER_TRIAL',
					{
						trialId: trialId,
						decisions: {},
					},
				);
			}

			if (!context.state.decisionsPerTrial[trialId]) {
				context.dispatch('fetchDecisions', trialId);
			}
		},
	},
};
